import { render, staticRenderFns } from "./groupReportCenter.vue?vue&type=template&id=13156482&scoped=true&"
import script from "./groupReportCenter.vue?vue&type=script&lang=js&"
export * from "./groupReportCenter.vue?vue&type=script&lang=js&"
import style0 from "./groupReportCenter.vue?vue&type=style&index=0&id=13156482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13156482",
  null
  
)

export default component.exports